import { useAppConstantsContext } from '@/context/AppConstants';
import { Link, Text } from '@/theme/index';

export function WarningFooter() {
  const {
    links: { tosLink },
  } = useAppConstantsContext();
  return (
    <Text variant="body2" color="grey.700" sx={{ marginTop: 2.5 }}>
      <strong>WARNING:</strong> Please be advised, numbers and addresses may be
      associated with do-not-call, unsubscribe or other telemarketing activity
      contact restrictions and, as a reminder, our{' '}
      <Link
        className="link"
        href={tosLink}
        target="_blank"
        rel="noopener noreferrer"
        color="success.main"
      >
        Terms
      </Link>{' '}
      strictly prohibit use of our data for spam and other marketing activity.
    </Text>
  );
}
